import { render, staticRenderFns } from "./TiposVendaForm.vue?vue&type=template&id=47957648&scoped=true&"
import script from "./TiposVendaForm.vue?vue&type=script&lang=js&"
export * from "./TiposVendaForm.vue?vue&type=script&lang=js&"
import style0 from "./TiposVendaForm.vue?vue&type=style&index=0&id=47957648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47957648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow})
